import { Box } from "@chakra-ui/react";

export const ImagePlaceholder = ({ minH = "200px", ...props }) => {
  return (
    <Box
      bg="gray.100"
      minH={minH}
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    />
  );
};
